import { Button } from "@/components/ui/button";
import { ShoppingCart, Loader2 } from "lucide-react";
import { fmtQty } from "@/lib/constants";
import { DT } from "@/components/ui/denseTable";

function ShortageRow({ m, isOrdered, onRaisePO }) {
  const short = m.shortage > 0;
  return (
    <tr className={`border-b border-slate-100 transition-colors duration-150 ${short ? "bg-red-50/70 hover:bg-red-100/80" : "even:bg-slate-50/60 hover:bg-slate-100/80"}`} data-testid={`shortage-row-${m.sku}`}>
      <td className="px-3 py-2">
        <p className={`font-semibold ${short ? "text-red-700" : "text-slate-700"}`}>{m.name}</p>
        <p className="text-[10px] text-slate-400 font-mono-data">{m.sku}{m.supplier ? ` · ${m.supplier}` : ""}</p>
      </td>
      <td className="px-3 py-2 text-right font-mono-data text-slate-600">{fmtQty(m.required, m.unit)} {m.unit}</td>
      <td className={`px-3 py-2 text-right font-mono-data ${short ? "text-red-600 font-semibold" : "text-slate-600"}`}>{fmtQty(m.in_stock, m.unit)} {m.unit}</td>
      <td className="px-3 py-2 text-right font-mono-data font-bold text-red-600" data-testid={`shortage-amt-${m.sku}`}>{short ? `${fmtQty(m.shortage, m.unit)} ${m.unit}` : "—"}</td>
      <td className="px-3 py-2 text-right">
        {short && isOrdered && <span className="text-[11px] text-emerald-600">Ordered ✓</span>}
        {short && !isOrdered && m.item_type === "mfg_spare" && (
          <span className="inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700" data-testid={`shortage-make-hint-${m.sku}`}>Build in-house · Work Orders tab</span>
        )}
        {short && !isOrdered && m.item_type !== "mfg_spare" && (
          <Button size="sm" variant="outline" className="h-7 text-[11px]" onClick={() => onRaisePO(m)} data-testid={`shortage-po-${m.sku}`}>
            <ShoppingCart className="h-3 w-3 mr-1" />Create PO
          </Button>
        )}
      </td>
    </tr>
  );
}

// Loading / empty / table states for the material check.
export function ShortageTable({ loading, materials, ordered, onRaisePO }) {
  if (loading) {
    return <div className="py-10 text-center text-slate-400 text-sm"><Loader2 className="h-5 w-5 animate-spin inline mr-2" />Checking BOM…</div>;
  }
  if (materials.length === 0) {
    return <p className="py-8 text-center text-slate-400 text-sm" data-testid="shortage-no-bom">This product has no BOM recipe — no materials to check.</p>;
  }
  return (
    <div className="overflow-x-auto max-h-[50vh]">
      <table className={DT.table}>
        <thead className={DT.thead}>
          <tr className={DT.headerRow}>
            <th className="text-left px-3 py-2 font-semibold">Material</th>
            <th className="text-right px-3 py-2 font-semibold">Required</th>
            <th className="text-right px-3 py-2 font-semibold">In Stock</th>
            <th className="text-right px-3 py-2 font-semibold">Shortage</th>
            <th className="text-right px-3 py-2 font-semibold">Order</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {materials.map((m) => <ShortageRow key={m.item_id} m={m} isOrdered={!!ordered[m.item_id]} onRaisePO={onRaisePO} />)}
        </tbody>
      </table>
    </div>
  );
}
